/**
 * 콜봇 월 정산 목록의 구분·검색·정렬을 sessionStorage 에 두고 읽는다(브라우저 전용).
 *
 * 요청: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 1" — 상세에서 돌아오면 같은 달·필터가 보인다.
 *  - 목록이 쓰고, 상세의 `← 병원 목록`·기본 요율 화면의 `← 월 정산` 이 읽는다(settlementListLocation).
 *  - 키와 값 모양(기본값을 뺀 JSON)은 settlementRules 의 LIST_QUERY_STORAGE_KEY·serializeListQuery·parseListQuery 를 쓴다.
 *  - sessionStorage 가 막힌 환경(사생활 보호 모드·저장소 차단)에서도 화면은 돈다 — 읽기는 {}, 쓰기는 무시한다.
 */
import { LIST_QUERY_STORAGE_KEY, parseListQuery, serializeListQuery } from './settlementRules.js';

/**
 * 목록이 남긴 구분·검색·정렬. 없거나 깨졌거나 읽지 못하면 {}(같은 달 기본 목록).
 * @returns {{ cat?: string, q?: string, sort?: string }}
 */
export function readSavedListQuery() {
  try {
    return parseListQuery(sessionStorage.getItem(LIST_QUERY_STORAGE_KEY));
  } catch {
    return {};
  }
}

/**
 * 목록의 구분·검색·정렬을 남긴다(기본값은 빠진다).
 * @param {{ cat?: unknown, q?: unknown, sort?: unknown }|string|null|undefined} query 목록 필터
 *   (sort 는 'key.dir' 또는 { key, dir }) 또는 serializeListQuery 가 만든 JSON
 * @returns {boolean} 저장했으면 true
 */
export function writeSavedListQuery(query) {
  try {
    const filter = typeof query === 'string' ? parseListQuery(query) : query;
    sessionStorage.setItem(LIST_QUERY_STORAGE_KEY, serializeListQuery(filter));
    return true;
  } catch {
    return false;
  }
}
